<template>
  <as-dialogo ref="dialogoAgendamentos" title="Agendamentos" max-width="960px">
    <div :style="loading ? 'filter: opacity(0.5); pointer-events: none' : ''">
      <v-row dense style="text-align: center; pointer-events: none;">
        <v-col cols="6">
          <v-text-field
            hide-details
            label="Rodada"
            v-model="rodada.nome"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            hide-details
            label="Cidade"
            v-model="rodada.cidade_nome"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            hide-details
            label="Estado"
            v-model="rodada.estado_nome"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row style="text-align: center; padding: 0px 12px 12px">
        <v-select
          :items="fornecedores"
          label="Fornecedor"
          v-model="fornecedorSelecionado"
          item-text="nome_fantasia"
          item-value="id"
          hide-details
          return-object
          placeholder="Selecione um fornecedor"
          style="width:100%"
          @change="atualizar"
        />
      </v-row>

      <v-row dense style="text-align: center">
        <v-col cols="2">
          <v-btn
            v-if="!loading"
            large
            color="warning"
            width="100%"
            @click="atualizar"
          >
            Atualizar
          </v-btn>
        </v-col>
        <v-col
          cols="2"
          color="primary"
          v-for="(dia, i) in agenda"
          :key="i"
          style="pointer-events: none;"
        >
          <v-btn large color="primary" width="100%">{{ dia.dia }}</v-btn>
          {{
            dia.data.toISOString().substring(8, 10) +
              "/" +
              dia.data.toISOString().substring(5, 7) +
              "/" +
              dia.data.toISOString().substring(0, 4)
          }}
        </v-col>
      </v-row>

      <v-row
        v-for="(hora, i) in horarios"
        :key="hora"
        dense
        :style="
          'text-align: center;border-radius: ' +
            (i === horarios.length - 1
              ? '0px 0px 6px 6px'
              : i === 0
              ? '6px 6px 0px 0px'
              : '0px') +
            '; background-color:' +
            getCorPeriodoDia(hora)
        "
      >
        <v-col
          cols="2"
          style="align-items: center; display: inline-grid; font-weight: 600; user-select: none;"
        >
          <span>{{ getPeriodoDia(hora) }}</span>
        </v-col>
        <v-col
          v-for="horario in agenda.map((item) => item.horarios[i])"
          :key="horario.dataHora"
          cols="2"
        >
          <v-tooltip
            left
            :color="getButtonColor(horario)"
            :disabled="horario.nome === null"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                name="horario-tag"
                :id="horario.dataHora"
                v-bind="attrs"
                v-on="on"
                :style="
                  checkDataHora(horario.dataHora) === 0
                    ? 'opacity: 0.3; filter: brightness(0.7); background-color: #f5f5f5 !important; pointer-events: none'
                    : ''
                "
                :color="getButtonColor(horario)"
                @click="() => agendar(horario)"
                >{{ horario.horario }}</v-btn
              >
            </template>
            <span>{{ horario.nome }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row dense style="text-align: center">
        <div class="mr-auto mt-auto" style="color: red">
          Horário de Brasília
        </div>
        <v-chip disabled class="mr-2 mt-3" small chip label color="#e0e0e0"
          >Indisponível</v-chip
        >
        <v-chip class="mr-2 mt-3" small chip label color="#e0e0e0"
          >Livre</v-chip
        >
        <v-chip class="mr-2 mt-3" small chip label color="error"
          >Agendado</v-chip
        >
        <v-chip class="mt-3" small chip label color="info"
          >Agendado para o fornecedor selecionado</v-chip
        >
      </v-row>
    </div>
    <v-progress-linear
      v-if="loading"
      buffer-value="55"
      color="success"
      stream
      value="30"
      class="mt-3"
    />

    <as-dialogo
      ref="dialogoHorario"
      title="Agenda"
      max-width="640px"
      @onFechar="cancelarHorario = false"
    >
      <v-row
        v-if="horario"
        dense
        style="text-align: center; pointer-events: none;"
      >
        <v-col cols="12">
          <v-text-field
            hide-details
            read-only
            label="Fornecedor"
            v-model="horario.nome"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row
        v-if="horario"
        dense
        style="text-align: center; pointer-events: none;"
      >
        <v-col cols="8">
          <v-text-field
            hide-details
            read-only
            label="Dia"
            :value="
              diasSemana[new Date(horario.dataHora).getUTCDay()] +
                ', ' +
                new Date(horario.dataHora).getUTCDate() +
                ' de ' +
                mesesAno[
                  new Date(horario.dataHora).getUTCMonth()
                ].toLowerCase() +
                ' de ' +
                new Date(horario.dataHora).getUTCFullYear()
            "
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            hide-details
            read-only
            label="Hora"
            v-model="horario.horario"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="horario" dense style="text-align: center">
        <v-checkbox
          v-model="cancelarHorario"
          label="Cancelar este agendamento"
          color="red"
          value="red"
          hide-details
        ></v-checkbox>
        <v-btn
          v-if="cancelarHorario"
          class="mt-auto ml-auto mr-1 text-white"
          color="error"
          @click="cancelar"
        >
          Cancelar
        </v-btn>
      </v-row>
    </as-dialogo>
  </as-dialogo>
</template>

<script>
import { uuid } from "vue-uuid";
import ServiceRodadas from "@/services/rodadas.js";
import ServiceAgendamentos from "@/services/agendamentos.js";

export default {
  name: "Agendamentos",
  props: {
    fornecedores: {
      type: Array,
    },
    fornecedor: {
      type: Object,
    },
    rodadaId: {
      type: Number,
    },
  },
  data() {
    return {
      fornecedorSelecionado: null,
      diasSemana: [],
      mesesAno: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      horarios: [],
      agenda: [],
      rodada: {},
      user: {},
      horario: null,
      loading: true,
      cancelarHorario: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    async abrir() {
      this.loading = true;
      this.fornecedorSelecionado = this.fornecedor;

      this.atualizar();

      this.$refs.dialogoAgendamentos.abrir();
    },

    async atualizar() {
      this.loading = true;

      const { data } = await ServiceRodadas.abrir(this.rodadaId);
      this.rodada = data.rodada;

      const { data: agenda } = await ServiceAgendamentos.index(this.rodadaId);

      this.diasSemana = [
        "Domingo",
        "Segunda",
        "Terça",
        "Quarta",
        "Quinta",
        "Sexta",
        "Sábado",
      ];
      this.horarios = [
        "00:00 - 01:30",
        "01:30 - 03:00",
        "08:00 - 09:30",
        "09:30 - 11:00",
        "11:00 - 12:30",
        "12:30 - 14:00",
        "14:00 - 15:30",
        "15:30 - 17:00",
        "17:00 - 18:30",
        "18:30 - 20:00",
        "20:00 - 21:30",
        "21:30 - 22:00",
        "22:00 - 23:30",
      ];

      const fim = new Date(this.rodada.data_fim);
      const dia = new Date(this.rodada.data_inicio);

      const mappedData = [];

      while (dia <= fim) {
        mappedData.push({
          dia: this.diasSemana[dia.getUTCDay()],
          data: new Date(dia.toISOString().substring(0, 10)),
          horarios: this.horarios.map((horario) => {
            const dataHora = new Date(
              new Date(dia.toISOString()).setUTCHours(
                horario.substring(0, 2),
                horario.substring(3, 5)
              )
            );
            const found = agenda.agendamentos.find(
              (item) =>
                item.data_hora ===
                dataHora.getUTCFullYear() +
                  "-" +
                  String(dataHora.getUTCMonth() + 1).padStart(2, "0") +
                  "-" +
                  String(dataHora.getUTCDate()).padStart(2, "0") +
                  " " +
                  String(dataHora.getUTCHours()).padStart(2, "0") +
                  ":" +
                  String(dataHora.getUTCMinutes()).padStart(2, "0") +
                  ":00"
            );
            const fornecedorFound = found
              ? this.fornecedores.find(
                  (forn) => forn.id === found.fornecedor_id
                )
              : null;

            return {
              horario,
              dataHora: new Date(dia.toISOString()).setUTCHours(
                horario.substring(0, 2),
                horario.substring(3, 5)
              ),
              // fornecedorId: fornecedorFound ? fornecedorFound.id : null,
              // fornecedor: fornecedorFound
              //   ? fornecedorFound.nome_fantasia
              //   : null,
              // clienteId: this.user.cliente_id,
              // id: found ? found.id : null,

              fornecedorId: found ? found.fornecedor_id : null,
              nome: fornecedorFound ? fornecedorFound.nome_fantasia : null,
              clienteId: found ? found.cliente_id : null,
              representanteId: found ? found.representante_id : null,
              id: found ? found.id : null,
              uuid: found ? found.uuid : null,
            };
          }),
        });
        dia.setDate(dia.getDate() + 1);
      }

      this.agenda = mappedData;

      this.loading = false;
    },
    getPeriodoDia(hora) {
      const horaInt = parseInt(hora.substring(0, 2));
      if (horaInt < 12) {
        return "Manhã";
      } else if (horaInt < 14) {
        return "Almoço";
      } else if (horaInt < 18) {
        return "Tarde";
      } else {
        return "Noite";
      }
    },
    getCorPeriodoDia(hora) {
      const horaInt = parseInt(hora.substring(0, 2));
      if (horaInt < 12) {
        return "lightyellow";
      } else if (horaInt < 14) {
        return "lightgrey";
      } else if (horaInt < 18) {
        return "#ffdc9b";
      } else {
        return "lightslategray";
      }
    },
    getButtonColor(horario) {
      if (!horario || !this.checkDataHora(horario.dataHora) === 0) {
        return "";
      } else if (this.fornecedorSelecionado.id === horario.fornecedorId) {
        return "info";
      } else if (horario.fornecedorId) {
        return "error";
      }
      return "";
    },
    checkDataHora(horario) {
      const minhaData = new Date();
      // Timezone de brasília - 3
      minhaData.setHours(minhaData.getHours() - 3);
      if (new Date(horario) < minhaData) {
        if (
          minhaData <
          new Date(horario).setMinutes(new Date(horario).getMinutes() + 90)
        ) {
          // Presente
          return 2;
        }
        // Passado
        return 0;
      }

      // Futuro
      return 1;
    },
    agendar(horario) {
      if (!horario.fornecedorId) {
        this.loading = true;
        ServiceAgendamentos.salvar(2, {
          data_hora: new Date(horario.dataHora).toISOString(),
          uuid: uuid.v4(),
          cliente_id: this.user.cliente_id,
          fornecedor_id: this.fornecedorSelecionado.id,
          rodada_id: 2,
        }).then(() => {
          this.atualizar();
        });
      } else {
        this.horario = horario;
        this.abrirHorario();
      }
    },
    abrirHorario() {
      this.$refs.dialogoHorario.abrir();
    },
    cancelar() {
      this.cancelarHorario = false;
      this.$refs.dialogoHorario.fechar();

      ServiceAgendamentos.excluir(this.horario.id).then(() => {
        this.atualizar();
      });
    },
    fechar() {
      this.$refs.dialogoAgendamentos.fechar();
      this.$emit("success");
    },
  },
};
</script>
<style></style>
